import * as React from "react";
import { SVGProps } from "react";
function SvgInfoIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity={0.6}>
        <path
          opacity={0.3}
          d="M20 5a15 15 0 1 0 0 30 15 15 0 0 0 0-30Z"
          fill="#fff"
        />
        <path
          d="M21.667 28.333h-3.334v-10h3.334v10Zm0-13.333h-3.334v-3.333h3.334V15Z"
          fill="#fff"
        />
        <path
          d="M20 5a15 15 0 1 0 0 30 15 15 0 0 0 0-30Z"
          stroke="#fff"
          strokeWidth={2}
          strokeMiterlimit={10}
        />
      </g>
    </svg>
  );
}
export default SvgInfoIcon;
